/* people: екраните „Хора“ и редактирането на клиент (W3, 2026-09-30).
 * Същите ключове като en/people.ts. */
export default {
  people: {
    title: 'Хора',
    subtitle:
      'Всички, които могат да влизат в работното пространство на кантората, и какво вижда всеки от тях.',
    add: 'Добавяне на човек',
    back: 'Обратно към хората',
    emptyTitle: 'Още няма никого',
    empty: 'Добавете колега или човек от клиент, който да следи делата си.',
    group: {
      firm_main: 'Основен профил',
      firm_manager: 'Юристи в кантората',
      client_viewer: 'Хора от клиентите',
    },
    groupSub: {
      firm_main: 'Вижда и променя всичко и единствен може да добавя хора.',
      firm_manager: 'Работят по клиентите и марките, които са им дадени.',
      client_viewer:
        'Четат откритите дела на собствената си компания. Никога не виждат съвпаденията.',
    },
  },

  person: {
    newTitle: 'Нов човек',
    newSub:
      'Изберете кой е човекът и какво може да вижда. Отделно решавате дали да изпратите покана сега.',
    kind: {
      firm_main: 'Основен профил',
      firm_manager: 'Юрист в кантората',
      client_viewer: 'Човек от клиент',
    },
    kindHint: {
      firm_manager: 'Работи по клиентите и марките, които дадете: съвпадения, дела, документи.',
      client_viewer:
        'Само чете откритите дела на компаниите, които дадете. Не може да променя нищо.',
    },
    role: {
      senior_partner: 'Старши съдружник',
      partner: 'Съдружник',
      senior_associate: 'Старши сътрудник',
      counsel: 'Консултант',
      associate: 'Сътрудник',
    },
    status: {
      off: 'Изключен',
      notInvited: 'Без покана',
      invited: 'Поканен на {date}',
      expired: 'Поканата е изтекла',
    },
    form: {
      title: 'Кой е',
      sub: 'Името, както ще го виждат колегите, и езикът на имейлите.',
      kind: 'Вид профил',
      name: 'Име и фамилия',
      nameRequired: 'Въведете име',
      email: 'Имейл адрес',
      emailInvalid: 'Въведете валиден имейл адрес',
      emailHint: 'С този адрес се влиза в системата. По-късно не може да се променя.',
      role: 'Позиция в кантората',
      noRole: 'Не е посочена',
      language: 'Език',
      languageDefault: 'Не е избран (английски)',
      languageHint: 'Езикът на имейлите. След влизане човекът може да го смени сам.',
    },
    access: {
      title: 'Какво може да вижда',
      sub: {
        firm_manager:
          'Цели компании или само някои от марките на компания. Нищо друго не е видимо.',
        client_viewer: 'Компаниите, чиито открити дела може да чете. Нужна е поне една.',
      },
      whole: 'Цялата компания',
      some: 'Само някои марки',
      howMuch: 'Колко от тази компания',
      noMarks: 'Компанията още няма марки.',
      chooseMarks: 'Изберете поне една марка или дайте цялата компания.',
      search: 'Намерете клиентска компания…',
      dropPending: 'Без {name}',
      viewerNeedsOne: 'Добавете поне една компания: без нея човекът няма да вижда нищо.',
      give: 'Дай този достъп',
      given: 'Достъпът е даден',
      remove: 'Премахни',
      removeTitle: 'Премахване на достъпа до {what}?',
      removeBody: 'Спира да го вижда веднага. Нищо друго не се променя.',
      noneYet: 'Още не вижда нищо. Добавете компания по-долу.',
      mainSeesAll: 'Основният профил вижда цялата кантора. Няма какво да се избира.',
      wholeFirm: 'Цялата кантора',
      none: 'Още нищо',
      clients: '{n} компания | {n} компании',
      someMarks: '{name}: {n} марка | {name}: {n} марки',
    },
    invite: {
      title: 'Покана',
      sub: 'Имейл с връзка за избор на парола. Връзката работи веднъж, в рамките на 7 дни.',
      now: 'Изпрати покана по имейл сега',
      send: 'Изпрати покана',
      again: 'Изпрати нова покана',
      confirmTitle: 'Да се изпрати ли покана до {email}?',
      body: 'Човекът получава връзка, за да избере парола и да влезе.',
      replaces:
        'Човекът получава нова връзка за избор на парола. Изпратената по-рано спира да работи.',
      sent: 'Изпратено до {email}.',
      done: 'Поканата е изпратена',
      failed: 'Поканата не беше изпратена',
      hasPassword: 'Има парола и може да влиза. С нова покана може да избере друга.',
      /* Без точка след дата: българската дата свършва на „г.“. */
      waiting: 'Поканата е изпратена на {sent}; връзката работи до {until}',
      lapsed: 'Поканата е изпратена на {sent}, но връзката е изтекла неизползвана.',
      never: 'Още няма покана: без нея човекът не може да влезе.',
    },
    account: {
      title: 'Профилът',
      sub: 'Изключването запазва всичко направено; изтриването премахва самия профил.',
    },
    off: {
      action: 'Изключи',
      undo: 'Включи отново',
      confirmTitle: 'Да се изключи ли {name}?',
      body: 'Излиза от системата и не може да влезе, докато не го включите отново. Направеното остава.',
    },
    delete: {
      action: 'Изтрий',
      confirmTitle: 'Да се изтрие ли {name}?',
      body: 'Профилът и достъпът се премахват и не могат да се възстановят. Делата, възложени на този човек, остават без отговорник; записът за направеното остава.',
      done: '{name} е изтрит',
    },
    create: 'Добави човека',
    save: 'Запази',
    saved: 'Запазено',
    created: 'Човекът е добавен',
    createdSub: 'Не е изпратен имейл. Изпратете поканата, когато сте готови.',
    createdNoInvite: 'Човекът е добавен, но поканата не беше изпратена',
    failed: 'Не се получи',
    emailTaken: 'Вече има профил с този имейл адрес.',
    summary: 'Накратко',
  },

  editClient: {
    crumb: 'Редактиране',
    title: 'Редактиране на клиент',
    subtitle: 'Променете записаното за {name}. Запазват се само полетата, които промените.',
    save: 'Запази промените',
    saving: 'Запазване…',
    saved: 'Промените са запазени',
    failed: 'Промените не бяха запазени',
    notSaved: 'Нищо не се запазва, докато не натиснете „Запази промените“.',
    delete: {
      title: 'Изтриване на клиента',
      sub: 'Премахва компанията с нейната {n} марка, документите и съвпаденията ѝ и достъпа на всички до компанията. | Премахва компанията с нейните {n} марки, документите и съвпаденията им и достъпа на всички до компанията.',
      action: 'Изтрий клиента',
      confirmTitle: 'Да се изтрие ли {name}?',
      body: 'Нейната {n} марка, документите и съвпаденията ѝ и достъпът на всички до компанията се премахват. Това не може да се отмени. | Нейните {n} марки, документите и съвпаденията им и достъпът на всички до компанията се премахват. Това не може да се отмени.',
      done: '{name} е изтрит',
      failed: 'Клиентът не беше изтрит',
      hasCases: 'Има дела по опозиция. Първо ги изтрийте от страницата „Опозиции“.',
    },
  },
}
